export default __webpack_public_path__ + "static/media/seguisym.2f687631.ttf";